import { z } from 'zod';

export const RoleSchema = z.enum(['consulente', 'ristoratore', 'osa', 'staff']);
export type Role = z.infer<typeof RoleSchema>;

export const ROLE_LABELS: Record<Role, string> = {
  consulente: 'Consulente HACCP',
  ristoratore: 'Ristoratore',
  osa: 'Operatore Settore Alimentare',
  staff: 'Staff cucina',
};
